import {
    CadastroCanalAtendimentoInterface,
    CanalAtendimentoInterface,
} from "../../../../Interfaces/Geral/GestaoDeCadastro/TipoCanalAtendimento/CanalAtendimentoInterfaces";

import {
    CadastrarCanalAtendimentoService,
    DeletarCanalAtendimentoService,
    EditarCanalAtendimentoService,
    getCanalAtendimentoService,
    ListarCanalAtendimentoService,
} from "../../../../Services/Geral/GestaoDeCadastros/TipoCanalAtendimento/TipoCanalAtendimentoService";
import { Controller } from "../../../Controller";

export async function CadastrarCanalAtendimentoController(
    requestBody: CadastroCanalAtendimentoInterface
) {
    return Controller(CadastrarCanalAtendimentoService(requestBody));
}

export async function getCanalAtendimentoController(
    idCanalAtendimento: number
) {
    return Controller(getCanalAtendimentoService(idCanalAtendimento));
}

export async function DeletarCanalAtendimentoController(
    idCanalAtendimento: number
) {
    return Controller(DeletarCanalAtendimentoService(idCanalAtendimento));
}

export async function ListarCanalAtendimentoContoller(
    flListarTodos?: boolean | undefined
) {
    return Controller(ListarCanalAtendimentoService(flListarTodos));
}

export async function EditarCanalAtendimentoController(
    requestBody: CanalAtendimentoInterface
) {
    return Controller(EditarCanalAtendimentoService(requestBody));
}
